import React from 'react';

const SvgArrowUp = props => (
	<svg viewBox="0 0 24 24" {...props}>
		<path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
	</svg>
);

export default SvgArrowUp;
